import React, {createRef, useEffect, useRef, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import Latex from "../components/LatexComponent";
import CustomCheck2 from "../components/CustomCheck2";
import {trackGaussEvent} from "../helper/analytics";

let query = null

export default function CourseQuestions({hasAccess, questions, courseId, defaultLeson = null}) {
    const [isActiveOnMenu, setIsActiveOnMenu] = useState(false)
    const [isSendingQuestion, setIsSendingQuestion] = useState(false)
    const [leason, setLeason] = useState(defaultLeson)
    const [collapsedQuestion, setCollapsedQuestion ] = useState(null)
    const [questionsShow, setQuestionsShow] = useState(questions)
    const [showRelatedToLeason, setShowRelatedToLeason] = useState(false)
    const [isQuestionSentSuccessfully, setIsQuestionSentSuccessfully] = useState(false)

    const textareaRef = createRef()
    const sendQuestion = () => {

        if (!textareaRef.current) return

        const question = textareaRef.current.value

        if (!question) return

        setIsQuestionSentSuccessfully(true)
        setIsSendingQuestion(false)

        fetch(
            '/ajax/course/create-question',
            {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify({
                    course: courseId,
                    question,
                    leason: leason.slug,
                })
            }
        ).then(r => {
            console.log('sent')

        })
    }

    useEffect(() => {


        const diggestQuestions = () => {
            let defaultQuestions = questions

            if (query && query.length > 0) {
                defaultQuestions = defaultQuestions.filter(question => {
                    const search = `${question.question} ${question.answer} ${question.leason}`
                    return search.indexOf(query) > -1
                })
            }

            if(showRelatedToLeason) {
                defaultQuestions = defaultQuestions.filter(question => {
                    return question.leason_slug === leason.slug
                })
            }

            return defaultQuestions
        }
        const listener = (event) => {
            query = event.detail
            setQuestionsShow(diggestQuestions())
        }

        document.addEventListener('course_menu_questions_query', listener)

        setQuestionsShow(diggestQuestions())

        return () => {
            document.removeEventListener('course_menu_questions_query', listener)
        }
    }, [showRelatedToLeason])


    useEffect(() => {
        const listener = (event) => {
            const data = event.detail
            setLeason(data)
        }

        document.addEventListener('course_select_video', listener)

        return () => {
            document.removeEventListener('course_select_video', listener)
        }


    }, [])

    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            setIsActiveOnMenu(menuitem === 'faqs')

            if(menuitem === 'faqs') {
                trackGaussEvent('opening_questions', {})
            }
        }

        document.addEventListener('course_menu_tabs', listener)

        return () => {
            document.removeEventListener('course_menu_tabs', listener)
        }

    }, []);

    if (!isActiveOnMenu) return null;

    return (
        <Container>

            {!leason && (
                <NoCourseContainer>
                    Selecciona un video para poder hacer una pregunta relacionada
                </NoCourseContainer>
            )}
            {leason && !isSendingQuestion && (
                <HeaderContainer>
                    <RelatedQuestionsContainer>
                        <CustomCheck2 name={'some name'} onChange={(selected) => setShowRelatedToLeason(selected)}/>
                        <RelatedQuestionsLabel>Mostrar preguntas relacionadas al video</RelatedQuestionsLabel>
                    </RelatedQuestionsContainer>

                    {hasAccess &&  (
                        <ButtonContainer>
                            <Button inverse onClick={() => setIsSendingQuestion(!isSendingQuestion)}>Hacer mi
                                pregunta</Button>
                        </ButtonContainer>

                    )}
                </HeaderContainer>
            )}


            {isSendingQuestion && (
                <Form>
                    <TextArea ref={textareaRef} placeholder="Escribe aqui tu consulta"></TextArea>
                    <ButtonContainer>
                        <Button inverse onClick={() => setIsSendingQuestion(false)}>Cancelar</Button>
                        <Button onClick={sendQuestion}>Preguntar</Button>
                    </ButtonContainer>
                </Form>
            )}

            {isQuestionSentSuccessfully && (
                <QuestionSentSuccessfull>
                    Hemos recibido tu pregunta, respondemos y te avisaremos
                </QuestionSentSuccessfull>
            )}


            {questionsShow.map((question, idx) => {
                return (
                    <QuestionContainer
                        onClick={() => setCollapsedQuestion(collapsedQuestion === idx ? null : idx)}
                        key={`question_container_${idx}`}>
                        <UserDate>
                            <Username>{question.user}:</Username>

                        </UserDate>
                        <QuestionName><Latex message={question.question} /></QuestionName>
                        {collapsedQuestion === idx ? (<QuestionAnswer><Latex message={question.answer} /></QuestionAnswer>) : null}
                    </QuestionContainer>
                )
            })}

            {questionsShow.length === 0 && (<NoQuestions>Sin resultados</NoQuestions>)}

        </Container>
    )

}


const QuestionSentSuccessfull = styled.div`
    padding: 12px;
    text-align: center;
    color: white;
`

const NoCourseContainer = styled.div`
    padding: 12px;
    text-align: center;
    color: white;
`

const RelatedQuestionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 16px;
`

const RelatedQuestionsLabel = styled.div`
    margin-left: 4px;
    padding-top: 3px;
`
const Username = styled.div`
    font-size: 12px;
`

const UserDate = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px;
`

const NoQuestions = styled.div`
    padding: 48px;
    text-align: center;
`

const QuestionContainer = styled.div`
    margin: 8px;
    margin-top: 16px;
    border: 1px solid #1A2024;

    background-color: #1A2024;
    color: white;
    cursor:pointer;
    border-radius: 4px;

    &: hover {
        border: 1px solid #FA9F63;
        color: #FA9F63;
    }
`

const QuestionAnswer = styled.div`
    padding: 12px;
    padding-top: 8px;
    color: #F8FCDA;
`

const QuestionName = styled.div`
    font-size: 16px;
    padding: 12px;
    color: #A5ABAF;
`


const Container = styled.div`
   height: 70vh;
    overflow-y: scroll;
    padding-top: 24px;
`

const Form = styled.div`

`
const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px;

`

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 8px;

`

const Button = styled.div`
    text-align:center;
    border-radius: 4px;
    background-color: ${props => props.inverse ? 'transparent' : '#FA9F63'};
    border: 1px solid #FA9F63;
    padding: 8px;
    font-size: 18px;
    cursor:pointer;
    color: ${props => props.inverse ? '#FA9F63' : 'white'};

    &:hover {
        background-color: #c7824f;
    }

`

const TextArea = styled.textarea`
    width: 362px;
    height: 200px;
    margin-left: 4px;
`

if (document.getElementsByTagName('course-menu-questions')) {
    const elms = document.getElementsByTagName('course-menu-questions')

    for (let elm of elms) {
        const hasAccess = elm.attributes['has-access'].value === '1'
        const questions = JSON.parse(elm.attributes['questions'].value)
        const course = elm.attributes['course-id'].value
        const defaultLesson = elm.attributes['default-lesson'] ? JSON.parse(elm.attributes['default-lesson'].value) : null
        ReactDOM.render(<CourseQuestions hasAccess={hasAccess} questions={questions} courseId={course} defaultLeson={defaultLesson}/>, elm);
    }
}
